import { getReq } from '../service/API'
import useSWR from 'swr'
import { ENDPOINTS } from '../service/ENDPOINTS'

export const useNextPhase = (projectId: string, subjectId: string) => {
  const p = ENDPOINTS.PHASES.GET_NEXT_PHASE_BY_SUBJECT_ID(projectId, subjectId)

  const { data, error, mutate } = useSWR(p, getReq, { suspense: false })

  return {
    data: !data ? data : data.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}
